var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"navbar navbar-expand-lg"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.routeName))])])
}
var staticRenderFns = []

export { render, staticRenderFns }